import {Subscription} from 'rxjs/Subscription';
import {Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {AuthorDataService} from "./authorData.service";
import {ModalService} from "../modal.service";
import {LoadingService} from "../loading.service";
import {LoggerService} from "../logger.service";
import {
    AuthorEntirePollResponse,
    AuthorPollResponse,
    AuthorRecordsResponse,
    DataRequestOptions,
    PollListResponse,
    PollResultsResponse,
    ResponsesNum
} from '../../models';
import {EventService} from '../event.service';
import {StoreEventsEnum} from '../../enums/StoreEventsEnum.enum';

@Injectable()
export class AuthorService {

    private disposable: Subscription;

    constructor(private router: Router,
                private dataService: AuthorDataService,
                private modalService: ModalService,
                private eventService: EventService,
                private loadingService: LoadingService,
                private logger: LoggerService) {
    }

    getAuthorEntirePoll(pollId: number, onReady: ((response: AuthorEntirePollResponse) => void)): void {

        if (!this.cancelOperation()) {
            return;
        }
        this.disposable = this.dataService.getAuthorEntirePoll(pollId, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: getAuthorEntirePoll AuthorEntirePollResponse:', data);
                    onReady(data);
                }
            );
    }

    getAuthorPoll(pollId: number, onReady: ((response: AuthorPollResponse) => void)): void {

        if (!this.cancelOperation()) {
            return;
        }
        this.disposable = this.dataService.getAuthorPoll(pollId, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: getPoll AuthorPollResponse:', data);
                    onReady(data);
                }
            );
    }

    getAuthorTakerGroups(pollId: number, onReady: ((response: AuthorRecordsResponse) => void)): void {

        this.disposable = this.dataService.getAuthorTakerGroups(pollId, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: getAuthorTargetGroups:', data);
                    onReady(data);
                }
            );
    }

    getAuthorAuthorGroups(pollId: number, onReady: ((response: AuthorRecordsResponse) => void)): void {

        this.disposable = this.dataService.getAuthorAuthorGroups(pollId, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: getAuthorAuthorGroups:', data);
                    onReady(data);
                }
            );
    }

    updateTGroups(pollId: number, targetGroups: any, onReady: ((response: AuthorRecordsResponse) => void)): void {

        this.disposable = this.dataService.updateTakerGroups(pollId, targetGroups, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: updateTGroups:', data);
                    onReady(data);
                }
            );
    }

    updateAGroups(pollId: number, targetGroups: any, onReady: ((response: AuthorRecordsResponse) => void)): void {

        this.disposable = this.dataService.updateAuthorGroups(pollId, targetGroups, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: updateAGroups:', data);
                    onReady(data);
                }
            );
    }

    deleteTGroups(pollId: number, targetGroups: any, onReady: ((response: AuthorRecordsResponse) => void)): void {

        this.disposable = this.dataService.deleteTakerGroups(pollId, targetGroups, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: deleteTGroups:', data);
                    onReady(data);
                }
            );
    }

    deleteAGroups(pollId: number, targetGroups: any, onReady: ((response: AuthorRecordsResponse) => void)): void {

        this.disposable = this.dataService.deleteAuthorGroups(pollId, targetGroups, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: deleteAGroups:', data);
                    onReady(data);
                }
            );
    }

    getResponsesNum(pollId: number, onReady: ((response: ResponsesNum) => void)): void {

        this.disposable = this.dataService.getResponsesNum(pollId, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: getResponsesNum:', data);
                    onReady(data);
                }
            );
    }

    getAuthorPollsList(queryParams: {}, onReady: ((response: PollListResponse) => void)): void {

        this.disposable = this.dataService.getAuthorPollsList(queryParams, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: getAuthorPollsList:', data);
                    onReady(data);
                }
            );
    }

    getAuthorPollResults(pollId: number, onReady: ((response: PollResultsResponse) => void)): void {

        this.disposable = this.dataService.getAuthorPollResults(pollId, this.getDataRequestOptions())
            .subscribe(
                data => {
                    this.logger.log('AuthorService: getAuthorPollResults:', data);
                    onReady(data);
                }
            );
    }

    checkResponsesNum(pollId: number, pollTitle?: string, func?: (recordsNum: number) => void) {

        this.getResponsesNum(pollId, response => {
            if (response.record > 0) {
                const title = `This poll has ${response.record} response(s).`;
                const ret = this.eventService.emit({
                    type: StoreEventsEnum.OPEN_MODAL, payload: {
                        id: 'modal_pollHasResponses',
                        modal: {title: title},
                        action: (args: any) => {
                            this.router.navigate([`/author/edit/${pollId}/results`]);
                        },
                        callback: (result) => {
                            if (result.value) {
                                if (func) {
                                    func(response.record);
                                }
                            }
                        }
                    }
                });
            } else {
                if (func) {
                    func(response.record);
                }
            }
        });
    }


    /**
     *  Always call cancelOperation before this.takerService.<FUN>
     */
    cancelOperation(): boolean {

        this.logger.log('AuthorService: cancelOperation', this.disposable);

        this.loadingService.emit(false);

        // unsubscribe from the current HTTP request
        if (this.disposable && !this.disposable.closed) {
            this.disposable.unsubscribe();
            this.disposable = null;
        }

        return true;
    }

    private getDataRequestOptions(): DataRequestOptions {

        const options: DataRequestOptions = new DataRequestOptions(false, null/*token*/, '1'/*lockOnce*/);

        return options;

    }

}

